"use strict";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const initSlider = document.querySelector(".o-home-hero__cards");
        if (!initSlider) return;

        const swiper = new Swiper(".o-home-hero__cards", {
            modules: [Navigation],
            slidesPerView: 1.25,
            spaceBetween: 16,
            centeredSlides: true,
            autoHeight: false,
            navigation: {
                nextEl: ".o-home-hero__arrow--next",
                prevEl: ".o-home-hero__arrow--prev",
            },
            breakpoints: {
                680: {
                    initialSlide: 1,
                    slidesPerView: 2,
                },
                1280: {
                    centeredSlides: false,
                    initialSlide: 0,
                    loop: false,
                    slidesPerView: 3,
                },
            },
        });
    });
}
